import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { makeMemberMap } from "../services/hooks/MembersList";
import { makeTeamTypesMap } from "../services/hooks/TeamTypeList";
import type { AppDispatch, RootState } from "./index";

// Use throughout app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function selectMemberMap() {
  return makeMemberMap(useAppSelector(state => state.memberList.members));
}
export function selectTeamTypeMap() {
  return makeTeamTypesMap(useAppSelector(state => state.teamTypes.teamTypes));
}
